import { takeLatest, put, all } from 'redux-saga/effects';

import api from 'apiSingleton';

import * as actionTypes from 'redux/payment/actionTypes';
import {
    getMerchantDataUpsell as getMerchantDataUpsellAction,
    setLoadingStatus,
    setMerchantDataUpsell,
    setOrderId,
} from 'redux/payment/actions';

import { MerchantDataResponseType } from 'types/payments/paymentApiInterfaces';

export function* getMerchantDataSagaUpsell({ payload }: ReturnType<typeof getMerchantDataUpsellAction>) {
    try {
        yield put(setLoadingStatus(true));

        const merchantData: MerchantDataResponseType = yield api.payment.getMerchantData(payload);

        yield put(setOrderId(merchantData?.order_id));
        yield all([
            put(
                setMerchantDataUpsell({
                    merchant: merchantData?.merchant,
                    signature: merchantData?.signature,
                    paymentIntent: merchantData?.payment_intent,
                })
            ),
            put(setLoadingStatus(false)),
        ]);
    } catch (e) {
        throw e;
    }
}

export const getMerchantDataUpsell = [takeLatest(actionTypes.GET_MERCHANT_DATA_UPSELL, getMerchantDataSagaUpsell)];
